"use client";

import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { PATH_HOME } from ".constants/links";
import { Button, TButtonProps } from "@cloai/uikit";
import { useRouter, usePathname } from "next/navigation";
import { useCookies } from "react-cookie";

import { setCookie } from "@/app/_actions/setCookie";
import { useGTMContext } from "@/providers";
import { cn } from "@/utils/cn";

export const CtaButton = ({
  size = "lg",
  color = "primary",
  radius = "md",
  wide,
  centerText = true,
  className,
  children,
  ...props
}: TButtonProps) => {
  const { sendGTM } = useGTMContext();
  const router = useRouter();
  const pathname = usePathname();
  const [cookies] = useCookies([COOKIES.RULES_ACCEPTED]);

  const onTryFree = async () => {
    if (!cookies.rulesAccepted) {
      return;
    }

    sendGTM({ event: GE.CHOOSETRYFREE });

    await setCookie(COOKIES.APP, "1", {
      maxAge: COOKIES_TIMES.DAY_1,
    });

    if (pathname !== PATH_HOME) {
      router.push(PATH_HOME);
    } else {
      window.scrollTo(0, 0);
    }
  };

  return (
    <Button
      size={size}
      color={color}
      radius={radius}
      wide={wide}
      centerText={centerText}
      onClick={onTryFree}
      disabled={!cookies.rulesAccepted}
      className={cn("relative z-2 min-w-60", className)}
      {...props}
    >
      {children}
    </Button>
  );
};
